import Axios from 'axios';
import { servicesManager } from '../App.js';
import { user } from '@ohif/core';
import { createHashHistory } from 'history';

const Instance = Axios.create();

const handleError = error => {
  // console.log(JSON.stringify(error)) // for debug
  const history = createHashHistory(); // hash模式
  const { UINotificationService } = servicesManager.services;
  // if (error === undefined || error.code === 'ECONNABORTED') {
  //   // message.warning('服务请求超时')
  //   console.log('服务请求超时');
  //   return Promise.reject(error);
  // }
  if (error === undefined) {
    console.log('服务请求超时');
    return Promise.reject(error);
  }
  if (error.message === 'ECONNABORTED') {
    console.log('服务请求超时');
    return Promise.reject(error);
  }
  if (error.message === 'Network Error') {
    console.log('网络连接失败');
    return Promise.reject(error);
  }
  const { response = error } = error;
  const {
    status,
    // statusText,
    data: { msg = '服务器发生错误' },
  } = response;
  // const { dispatch } = store
  // const text = codeMessage[status] || statusText || msg;

  if ([status, response.data.httpCode].includes(400)) {
    // message.warning('账户或密码错误！')
    // dispatch(routerRedux.push('/user/login'))
    UINotificationService.show({
      title: '系统提示',
      message: response.data.tip,
      type: 'error',
      autoClose: true,
    });
    return;
  }
  const info = response.data;
  if (status === 401 || info.status === 40101) {
    history.push('/login');
    // dispatch({
    //     type: 'login/logout',
    // })
    // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
    //     confirmButtonText: '重新登录',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    // }).then(() => {
    //     store.dispatch('LogOut').then(() => {
    //         location.reload() // 为了重新实例化vue-router对象 避免bug
    //     })
    // })
  }
  if (status === 403) {
    // dispatch(routerRedux.push('/exception/403'))
    // Notification.warning({
    //     title: '禁止',
    //     message: info.message,
    //     type: 'error',
    //     duration: 2 * 1000,
    // })
  }
  if (info.status === 30101) {
    // dispatch(routerRedux.push('/exception/500'))
    // Notification.warning({
    //     title: '失败',
    //     message: info.message,
    //     type: 'error',
    //     duration: 2 * 1000,
    // })
  }
  if (response.status === 504) {
    // dispatch(routerRedux.push('/exception/500'))
    // Message({
    //     message: '后端服务异常，请联系管理员！',
    //     type: 'error',
    //     duration: 5 * 1000,
    // })
  }
  // message.error(`${status}:${text}`)
  // throw error
  // return error
  return Promise.reject(error);
};

// axiosSetting.js
// request拦截器
Instance.defaults.withCredentials = true;
Instance.interceptors.request.use(
  config => {
    // Do something before request is sent
    // let token = localStorage.getItem('ic-token');
    const accessToken = user && user.getAccessToken && user.getAccessToken();
    config.headers.Authorization = accessToken;
    config.headers.token = accessToken;
    config.headers.source = '01';
    config.headers.Accept = '*/*';
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// respone拦截器
Instance.interceptors.response.use(response => {
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  const res = response.data;
  // if (response.status === 401 || res.status === 40101) {
  //   MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //     confirmButtonText: '重新登录',
  //     cancelButtonText: '取消',
  //     type: 'warning'
  //   }).then(() => {
  //     store.dispatch('LogOut').then(() => {
  //       location.reload() // 为了重新实例化vue-router对象 避免bug
  //     })
  //   })
  //   return Promise.reject('error')
  // }
  // if (res.status === 30101) {
  //   Message({
  //     message: res.message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject('error')
  // }
  // if (res.status === 40301) {
  //   Message({
  //     message: '当前用户无相关操作权限！',
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject('error')
  // }
  const { UINotificationService } = servicesManager.services;
  if (['000002', '000004'].includes(res.reponseCode)) {
    UINotificationService.show({
      title: '系统提示',
      message: res.tip,
      type: 'success',
      autoClose: true,
    });
  }

  if (response.status !== 200 && res.status !== 200) {
    console.log(response);
    // message.error(response.data.message)
    // notification.error({
    //     message: res.status,
    //     description: res.message,
    // })
  } else {
    if (response.config.headers.isUpload) return response;
    if (response.config.responseType === 'blob') return response;
    if (res.httpCode !== 200) return handleError(response);
    return response.data;
  }
}, handleError);

export default Instance;
